export abstract class AuthenticationAbstractService {

    abstract get token();

    abstract set token(token: string);

    abstract get isAuthenticated(): boolean;

    abstract login(auth: string): any;

    abstract logout(): any;
}